import React, { useEffect, createElement } from 'react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  useEffect(() => {
    // Preload the LCP image for better performance
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = 'https://cdn.magicpatterns.com/uploads/pxtCzzbsE2AVRW2JRw1DED/docente360-pack2-1200.webp';
    link.imageSrcset = 'https://cdn.magicpatterns.com/uploads/pxtCzzbsE2AVRW2JRw1DED/docente360-pack2-1200.webp 768w';
    link.fetchPriority = 'high';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);
  return <section className="pt-16 md:pt-24 pb-8 md:pb-12 px-4 bg-transparent text-center" data-id="element-155">
      <div className="max-w-4xl mx-auto" data-id="element-156">
        <div className="inline-block bg-yellow-100/10 text-yellow-400 border border-yellow-400/20 font-bold px-4 py-2 rounded-full md:mb-6 text-[14px] pt-[5px] pb-[5px] mt-[-20px] mb-[-20px]" data-id="element-157">
          ⭐ EL SISTEMA #1 PARA DOCENTES ARGENTINOS QUE QUIEREN RECUPERAR SUS
          FINES DE SEMANA ⭐
        </div>

        <div className="flex flex-col items-center justify-center mt-4 mb-8" data-id="element-158">
          <h1 className="md:text-5xl font-black tracking-tight text-[24px] text-[#F5F7FF] leading-tight" data-id="element-159">
            Dejá de pasarte el domingo
          </h1>
          <h1 className="md:text-5xl font-black tracking-tight text-[24px] text-[#E9FF00] leading-tight mt-[10px] mb-[10px]" data-id="element-160">
            PLANIFICANDO , CORRIGIENDO E INFORMANDO
          </h1>
        </div>

        <div className="relative w-11/12 max-w-lg md:max-w-2xl mx-auto md:mb-6 aspect-[3/4] md:aspect-[4/5] mt-[-40px] mb-[-80px]" data-id="element-161">
          <a href="#compra" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" data-id="element-162">
            <picture data-id="element-163">
              <img src="https://cdn.magicpatterns.com/uploads/pxtCzzbsE2AVRW2JRw1DED/docente360-pack2-1200.webp" alt="Sistema Docente 360" width={768} height={1024} fetchPriority="high" loading="eager" className="w-full h-auto drop-shadow-2xl rounded-xl object-contain" data-id="element-164" />
            </picture>
          </a>
        </div>

        <h2 className="md:text-3xl font-bold text-gray-200 mb-3 md:mb-4 text-[20px]" data-id="element-165">
          El sistema completo de IA para docentes argentinos que resuelve el
          100% de tu carga pedagógica — en minutos, no en horas.
        </h2>

        <p className="text-xl md:text-2xl italic text-gray-400 font-medium mb-4 md:mb-6" data-id="element-166">
          "Usando solo ChatGPT gratuito."
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-5 md:mb-6" data-id="element-167">
          <span className="flex items-center gap-2 bg-white/5 border border-white/10 px-4 py-2 rounded-lg font-semibold text-white" data-id="element-168">
            📄 100% PDF
          </span>
          <span className="flex items-center gap-2 bg-white/5 border border-white/10 px-4 py-2 rounded-lg font-semibold text-white" data-id="element-169">
            ⚡ Acceso inmediato
          </span>
          <span className="flex items-center gap-2 bg-white/5 border border-white/10 px-4 py-2 rounded-lg font-semibold text-white" data-id="element-170">
            🇦🇷 Alineado al NAP
          </span>
        </div>

        <div className="max-w-2xl mx-auto mb-4" data-id="element-171">
          <CTAButton text="👉 QUIERO MI SISTEMA DOCENTE 360 AHORA →" href="#compra" isLink={true} data-id="element-172" />
        </div>

        <div className="max-w-xl mx-auto text-center text-xs md:text-sm text-gray-600 space-y-0.5 mb-4" data-id="element-173">
          <p data-id="element-174">Acceso inmediato · Garantía 30 días · Sin suscripción mensual</p>
        </div>

        <div className="flex justify-center mb-2" data-id="element-175">
          <img src="https://cdn.magicpatterns.com/uploads/uVMmdt8ApnQFVgCwQoFmbv/garantia-7-dias-250.webp" alt="Garantía 7 días de reembolso" className="h-14 w-14 md:h-16 md:w-16 object-contain" data-id="element-176" />
        </div>
      </div>
    </section>;
}